import { isErrorEmail } from '../../../../Email'
import { EntityArchivedIcon, EntityTag } from '../../../../Entity'
import { getTagActionSize, TAG_HEIGHT } from '../../../../Tag'
import { getAttachedRequestRecipientTagName } from '../RequestProfileTabEmailsCreateEmailPopUp.utils'

import * as styles from './AttachedRequestRecipientTag.module.css'

import ServiceRequestIcon from '../../../../../icons/service-request.svg'

function AttachedRequestRecipientTag({
  errorItems,
  item,
  printer,
  qaName,
  tooltip,
  onDeleteOption,
}) {
  const tagName = getAttachedRequestRecipientTagName(item)
  const isErrorItem = isErrorEmail(errorItems, item, printer)
  const height = TAG_HEIGHT.height32

  function handleDeleteOption() {
    onDeleteOption(item)
  }

  return (
    <EntityTag
      afterContent={
        item.isArchivedRequest ? (
          <EntityArchivedIcon size={getTagActionSize(height)} tooltip={null} />
        ) : null
      }
      avatarProps={{ Icon: ServiceRequestIcon }}
      className={styles.attachedRequestRecipientTag}
      height={height}
      isError={isErrorItem}
      name={tagName}
      qaName={qaName}
      removeTooltipKey='Select.TagClearTooltipKey'
      tooltip={tooltip || tagName}
      onRemove={isErrorItem ? handleDeleteOption : undefined}
    />
  )
}

export default AttachedRequestRecipientTag
